/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section1_P1Inputs */

const en_about_section1_p1 = /** @type {(inputs: About_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is a free, open-source collection of JSON tools designed for developers, data engineers, and anyone who works with JSON data. Every tool runs 100% in your browser: no server processing, no data collection, no account required.`)
};

const ko_about_section1_p1 = /** @type {(inputs: About_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 개발자, 데이터 엔지니어, JSON 데이터를 다루는 모든 사람을 위한 무료 오픈 소스 JSON 도구 모음입니다. 모든 도구는 100% 브라우저에서 실행되며, 서버 처리, 데이터 수집, 계정이 필요하지 않습니다.`)
};

const ja_about_section1_p1 = /** @type {(inputs: About_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは、開発者、データエンジニア、JSONデータを扱うすべての人のための無料オープンソースJSONツールコレクションです。すべてのツールは100%ブラウザで実行され、サーバー処理、データ収集、アカウント登録は不要です。`)
};

/**
* | output |
* | --- |
* | "PureJSON is a free, open-source collection of JSON tools designed for developers, data engineers, and anyone who works with JSON data. Every tool runs 100% i..." |
*
* @param {About_Section1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section1_p1 = /** @type {((inputs?: About_Section1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section1_p1(inputs)
	if (locale === "ko") return ko_about_section1_p1(inputs)
	return ja_about_section1_p1(inputs)
});